import { t } from 'app/core';
const root = 'report-version';

export const title = (key: string) => t(`${root}.title.${key}`);

export const label = (key: string) => t(`${root}.label.${key}`);
/*
export const headers = (t: TFunction, key: string) => t(`${root}.header.${key}`);

export const buttons = (t: TFunction, key: string) => t(`${root}.button.${key}`);

export const validations = (t: TFunction, key: string) => t(`${root}.validations.${key}`);
*/
export const messages = (key: string) => t(`${root}.messages.${key}`);
